---
fr:
  admin:
    production_periods:
      errors:
        generic: Impossible de charger les données des périodes de production.
      filters:
        date: Date
        month: Mois
        power_plant: Centrale
        week_start: Début de semaine
        year: Année
      labels:
        data_horizon: Limite de données
        power_plant: Centrale
        settled_source: 'Soldé : {source}'
        sources: Sources
        timezone: Fuseau horaire
        unknown: Inconnu
        unsettled_source: 'Non soldé : {source}'
      missing_segments:
        empty: Aucun segment manquant pour la vue sélectionnée.
        hours_missing:
          one: "{count} heure manquante"
          other: "{count} heures manquantes"
        title: Segments manquants
      summary:
        missing_unknown: Aucune information de couverture disponible.
        settled_hours_label: Heures soldées présentes
        settled_volume_label: Volume soldé (MWh)
        unsettled_hours_label: Heures non soldées présentes
        unsettled_volume_label: Volume non soldé (MWh)
      table:
        hour: Heure
        no_day_data: Aucune valeur horaire
        no_timeline_data: Aucune donnée de chronologie
        selected_series_mwh: Série sélectionnée (MWh)
        settled_mwh: Soldé (MWh)
        unsettled_mwh: Non soldé (MWh)
      timeline:
        coverage: Couverture
        label: Date
        missing_hours: Heures manquantes
        settled_coverage: Couverture soldée
        settled_hours: Heures soldées
        settled_volume: Soldé (MWh)
        unsettled_coverage: Couverture non soldée
        unsettled_hours: Heures non soldées
        unsettled_volume: Non soldé (MWh)
      title: Périodes de production
